<template>
  <div class="blog-langs">
    <h2> {{ $t("admin.choose_lang") }} </h2>
    <div class="langs-button">
      <router-link
        :to="
          $staffI18nRoute({
            name: 'CreateArticles',
            params: { lang: 'edit-ru' },
          })
        "
        class="langs"
        > {{ $t("admin.in_ru") }} </router-link
      >
      <router-link
        :to="
          $staffI18nRoute({
            name: 'CreateArticles',
            params: { lang: 'edit-en' },
          })
        "
        class="langs"
        > {{ $t("admin.in_en") }} </router-link
      >
      <router-link
        :to="
          $staffI18nRoute({
            name: 'CreateArticles',
            params: { lang: 'edit-uz' },
          })
        "
        class="langs"
        > {{ $t("admin.in_uz") }} </router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.blog-langs {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h2 {
    color: rgba(69, 69, 69, 1);
    font-size: 1.146vw;
    line-height: 1.354vw;
    font-weight: 400;
    margin-bottom: 2.865vw;
    margin: 2.865vw;
  }
  .langs-button {
    display: flex;
    .langs {
      width: 13.333vw;
      height: 5.521vw;
      border: 1px solid #9ec1ec;
      color: rgba(69, 69, 69, 1);
      font-size: 1.146vw;
      line-height: 1.354vw;
      font-weight: 400;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      &:first-child {
        margin-right: 2.865vw;
      }
      &:nth-child(3) {
        margin-left: 2.865vw;
      }
      &:focus,
      &:hover,
      &:active {
        background-color: #9ec1ec;
        transition: all 0.4s ease;
      }
    }
  }
}

@media screen and (max-width: 1366px) {
  .blog-langs {
    margin-top: 8vw;
    h2 {
      font-size: 2.865vw;
      line-height: 3.385vw;
      width: 56.12vw;
      text-align: center;
    }
    .langs-button {
      display: flex;
      gap: 4vw;
      height: 100%;
      .langs {
        width: 24.74vw;
        height: 9.635vw;
        font-size: 2.865vw;
        line-height: 3.385vw;
        &:nth-child(2) {
          margin-right: 0;
        }
        &:nth-child(3) {
          margin-left: 0;
        }
      }
    }
  }
}

@media screen and (max-width: 414px) {
  .blog-langs {
    gap: 9.333vw;
    height: 100%;
    margin-top: 15vw;
    h2 {
      font-size: 4.8vw;
      line-height: 5.867vw;
      width: 86.133vw;
    }
    .langs-button {
      gap: 9.333vw;
      flex-direction: column;
      .langs {
        width: 50.667vw;
        height: 19.733vw;
        font-size: 5.867vw;
        line-height: 6.933vw;
      }
    }
  }
}
</style>